import { createFileRoute } from "@tanstack/react-router";
import { ExecutionDetail } from "@/components/views/run/ExecutionDetail";

export const Route = createFileRoute("/runs/$runId")({
  component: RunDetailRoute,
});

function RunDetailRoute() {
  const { runId } = Route.useParams();
  return <ExecutionDetail runId={runId} />;
}
